import { createStyles } from '@material-ui/core/styles';

const styles = (theme: any) => createStyles({
  toolbar: {},
  quickLinksButton: {
    'width': '40px',
    'zIndex': 9999,
    'background': 'none',
    'boxShadow': 'none',
    'padding': 0,
    '& .MuiButton-label': {
      display: 'flex',
      flexDirection: 'column',
    },
    '&:hover': {
      background: 'none',
      boxShadow: 'none',
    }
  },
  quickLinksText: {
    color: '#000',
    opacity: 1,
    fontSize: '0.75rem',
    transition: 'font-size 0.2s, opacity 0.2s',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    transitionDelay: '0.1s',
    fontWeight: 600,
    textTransform: 'capitalize',
    minWidth: '80px',
  },
  menuItem: {
    minWidth: 200,
    color: theme.palette?.hyperLink,
    textDecoration: 'underline',
  },
  disabled: {
    fill: '#AAA !important',
    color: '#AAA !important',
  },
});

export default styles;
